/**
 * @typedef ClientIdInterceptorCreatorParams
 * @type {object}
 * @property {string} clientId
 */

/**
 * @param {ClientIdInterceptorCreatorParams} param0
 */
export function createClientIdInterceptor({ clientId }) {
  /**
   * @param {import('axios').AxiosRequestConfig} axiosRequestConfig
   */
  function interceptor(axiosRequestConfig) {
    const { data } = axiosRequestConfig;
    const dataWithClientId = {
      ...data,
      client_id: clientId,
    };

    return {
      ...axiosRequestConfig,
      data: dataWithClientId,
    };
  }

  return interceptor;
}
